import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconInformation({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M14 7A7 7 0 1 0 0 7a7 7 0 0 0 14 0zM6.145 4.046c0 .457.377.84.858.84a.843.843 0 1 0 0-1.686.846.846 0 0 0-.858.846zm.086 5.843a.769.769 0 1 0 1.538 0V6.592a.769.769 0 1 0-1.538 0V9.89z"/>
        </svg>
    );
}

export default IconInformation;
